import { assign } from "lodash";
import { Injectable } from "@angular/core";

import { ITCIEnvVars, TCI_ENVIRONMENT_VAR_TYPE } from "@tci/common";
import { NgEnvVarsService } from "./ng-env-vars.service";

export interface IGoogleAnalyticsDataObj {
  appName?: string;
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  environment?: string;
}

@Injectable()
export class NgAnalyticsService {
  private env = "";

  constructor(
    private envVars: NgEnvVarsService
  ) {}

  setCustomTag(
    category: string,
    action: string,
    label: string,
    event: string,
    customObj: IGoogleAnalyticsDataObj = {}
  ): void {
    const dataObj: IGoogleAnalyticsDataObj = assign({
      appName: "TCI",
      event: event || "trackEvent",
      eventCategory: category,
      eventAction: action,
      eventLabel: label || ""
    }, customObj);

    if (this.env === "") {
      this
        .envVars
        .getEnvVar(TCI_ENVIRONMENT_VAR_TYPE.ENVIRONMENT_TYPE)
        .map((envVars: ITCIEnvVars<any>) => {
          this.env = envVars.ENVIRONMENT_TYPE === "production" ? "prod" : "dev";
          dataObj.environment = this.env;
          (<any>window).dataLayer.push(dataObj);
        });
    } else {
      dataObj.environment = this.env;
      (<any>window).dataLayer.push(dataObj);
    }
  }
}
